import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { LOCATIONS_MAP_CONVERTER_TOKEN, LocationsMapConverter } from './locations-map.component.converter'
import {
  LOCATIONS_MAP_REGION_CONVERTER_TOKEN, LocationsMapRegionConverter
} from './locations-map-region/locations-map-region.component.converter'
import {
  LOCATIONS_MAP_LOCATION_CONVERTER_TOKEN, LocationsMapLocationConverter
} from './locations-map-region/locations-map-location/locations-map-location.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        locationsMapFeature: {
          module: () => import('./locations-map.module').then((m) => m.LocationsMapModule),
          cmsComponents: ['location_map_map']
        },
      }
    }),
    {
      provide: LOCATIONS_MAP_CONVERTER_TOKEN,
      useExisting: LocationsMapConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        location_map_map: LOCATIONS_MAP_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: LOCATIONS_MAP_REGION_CONVERTER_TOKEN,
      useExisting: LocationsMapRegionConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        location_map_region: LOCATIONS_MAP_REGION_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: LOCATIONS_MAP_LOCATION_CONVERTER_TOKEN,
      useExisting: LocationsMapLocationConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        location_map_location: LOCATIONS_MAP_LOCATION_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class LocationsMapFeatureModule {}
